<template>
  <!--
    ESTADO B — O CAIS DO CLÃ (D22), na ordem do que muda o jogo: identidade com a posição no
    ranking, os três bônus como medidores (o motivo de existir do clã sai da terceira aba e vira o
    corpo da tela — problema 7), o baú do caixa com o contribuir, a tripulação em fichas, e o chat
    como mural. As abas morreram: era uma tela escondendo a si mesma.
  -->
  <div class="cais-do-cla">
    <!-- 1. Identidade -->
    <header class="cais-do-cla__identidade">
      <!-- A bandeira (D25) abre a identidade: é a cara do clã, e cara vem antes
           do nome em qualquer lugar que se reconheça de longe. -->
      <ClanBandeira
        :is-leader="isLeader"
        :inicial="clan.flag"
        @erro="$emit('chatError', $event)"
      />

      <div class="crescer">
        <h2 class="cais-do-cla__nome">{{ clan.name }}</h2>

        <!--
          O PAÍS (11/09/2026) — de onde o clã é. Não é a bandeira da esquerda: aquela é a cara do
          clã, esta é a origem. O líder troca aqui, porque errar o país na fundação não pode custar
          dissolver o clã. Sem país e sem ser líder, a linha não aparece: "Sem país" para quem não
          pode mudar nada seria ruído.
        -->
        <p v-if="clan.country || isLeader" class="cais-do-cla__pais">
          <BandeiraDePais v-if="clan.country" :codigo="clan.country" />
          <span>{{ nomeDoPaisDoCla || $t('clan.pais.nenhum') }}</span>
          <button
            v-if="isLeader"
            type="button"
            class="cais-do-cla__trocar-pais"
            :aria-expanded="String(escolhendoPais)"
            @click="escolhendoPais = !escolhendoPais"
          >
            {{ escolhendoPais ? $t('clan.pais.fechar') : $t('clan.pais.trocar') }}
          </button>
        </p>
        <EscolhaDePais
          v-if="isLeader && escolhendoPais"
          class="cais-do-cla__escolha-de-pais"
          so-painel
          :model-value="clan.country"
          :desabilitado="salvandoPais"
          @update:model-value="trocarPais"
        />

        <p class="cais-do-cla__tipo">
          <FishIcon :nome="clan.type === 'corporation' ? 'lock' : 'globe'" tamanho="miudo" />
          {{ $t(`clan.types.${clan.type}`) }}
          <span v-if="clan.rankingPosition" class="cais-do-cla__posicao t-numero">
            · {{ clan.rankingPosition }}º {{ $t('clan.rankingTitle') }}
          </span>
        </p>
        <p v-if="clan.description" class="cais-do-cla__descricao">{{ clan.description }}</p>

        <!--
          O NÍVEL DO CLÃ (1.1) — com o que FALTA, e não só o número.
          Nível solto é o problema 3 do D22 repetido: mostra estado, não progresso.
        -->
        <div class="cais-do-cla__nivel">
          <span class="cais-do-cla__nivel-numero t-numero">
            {{ $t('clan.nivel.rotulo') }} {{ clan.level }}
          </span>
          <span class="cais-do-cla__barra" :aria-label="$t('clan.nivel.rotulo')">
            <span class="cais-do-cla__barra-cheia" :style="{ width: `${percentualDeXp}%` }" />
          </span>
          <span class="cais-do-cla__nivel-falta t-numero">
            {{ formato(clan.xp) }} / {{ formato(clan.xpToNext) }}
          </span>
        </div>
        <p class="cais-do-cla__libera">
          {{ $t('clan.nivel.libera', { vagas: clan.slots, teto: clan.boostCap }) }}
        </p>
      </div>

      <FishButton
        v-if="isLeader"
        variante="perigo"
        tamanho="pequeno"
        icone="trash-alt"
        som="clique"
        @click="$emit('disband')"
      >
        {{ $t('clan.disband') }}
      </FishButton>
      <FishButton v-else tamanho="pequeno" icone="sign-out-alt" som="clique" @click="$emit('leave')">
        {{ $t('clan.leave') }}
      </FishButton>
    </header>

    <!-- 2. A META DA SEMANA (D22, proposta 2) — vem antes dos bonus porque e o que
         pede presenca; os bonus sao o que o caixa compra. -->
    <section class="cais-do-cla__meta">
      <ClanMetaDaSemana @erro="$emit('chatError', $event)" />
    </section>

    <!-- 3. Os três bônus, medidores horizontais — três é pouco para roda (D22). -->
    <section class="cais-do-cla__bonus" :aria-label="$t('clan.boostsTab')">
      <ClanBoostCard
        v-for="tipo in tiposDeBonus"
        :key="tipo"
        :type="tipo"
        :clan="clan"
        :is-leader="isLeader"
        @upgrade="$emit('upgradeBoost', { clanId: clan.id, boostType: $event })"
        @activate="$emit('activateBoost', { clanId: clan.id, boostType: $event })"
      />
    </section>

    <!-- 4. O baú do caixa (D15: o pacote tem o baú) e o quanto VOCÊ já pôs nele. -->
    <section class="cais-do-cla__caixa">
      <FishIcon nome="clan-bau" tamanho="enorme" />
      <div class="crescer">
        <p class="cais-do-cla__saldo t-numero">{{ formato(clan.balance) }}</p>
        <p class="cais-do-cla__saldo-rotulo">{{ $t('clan.balance') }}</p>
        <p class="cais-do-cla__moedas">
          <FishIcon nome="medal" tamanho="miudo" />
          {{ $t('clan.yourClanCoins') }}: <strong class="t-numero">{{ formato(playerClanCoins) }}</strong>
        </p>
      </div>
      <FishButton variante="primario" icone="hand-holding-usd" som="compra" @click="$emit('contribute')">
        {{ $t('clan.contribute') }}
      </FishButton>
    </section>

    <!-- 5. A LOJA DO CLA (D24) — a barraca no cais. Vem depois do bau porque o bau
         e a moeda dela: o membro doa, ganha pontos, e gasta aqui. -->
    <section class="cais-do-cla__loja">
      <ClanLoja :is-leader="isLeader" @erro="$emit('chatError', $event)" @comprou="$emit('jogadorMudou')" />
    </section>

    <!-- 6. O VARAL DE PEDIDOS (D22, proposta 3). Vem logo depois da barraca porque
         e a outra resposta a "me falta apetrecho" — a de graca, e entre pessoas. -->
    <section class="cais-do-cla__pedidos">
      <ClanPedidos @erro="$emit('chatError', $event)" @mudou="$emit('jogadorMudou')" />
    </section>

    <!-- 7. A tripulação, em fichas. -->
    <section class="cais-do-cla__tripulacao" :aria-label="$t('clan.membersTab')">
      <p class="cais-do-cla__rotulo">{{ $t('clan.membersTab') }} · {{ totalDeMembros }}</p>
      <ul class="cais-do-cla__fichas">
        <li class="cais-do-cla__ficha cais-do-cla__ficha--lider">
          <FishIcon nome="crown" tamanho="pequeno" />
          <span class="crescer">{{ clan.leader?.username || $t('clan.unknownLeader') }}</span>
          <span class="t-numero">Nv. {{ clan.leader?.level || '?' }}</span>
        </li>
        <li v-for="membro in membros" :key="membro.id" class="cais-do-cla__ficha">
          <FishIcon nome="user" tamanho="pequeno" />
          <span class="crescer">{{ membro.username }}</span>
          <span class="t-numero">Nv. {{ membro.level }}</span>
          <span v-if="isLeader" class="cais-do-cla__mando">
            <button
              type="button"
              class="cais-do-cla__mandinho"
              :title="$t('clan.transferLeadership')"
              @click="$emit('transfer', { clanId: clan.id, newLeaderId: membro.id })"
            >
              <FishIcon nome="crown" tamanho="miudo" />
            </button>
            <button
              type="button"
              class="cais-do-cla__mandinho"
              :title="$t('clan.kickMember')"
              @click="$emit('kick', { clanId: clan.id, playerId: membro.id })"
            >
              <FishIcon nome="user-times" tamanho="miudo" />
            </button>
          </span>
        </li>
      </ul>
    </section>

    <!-- 8. O QUADRO DE HONRA (7.4f). O ranking estava so na porta, onde quem NAO
         tem cla o ve; quem tem passou a nao ver mais o proprio lugar depois de
         entrar — que e a metade do problema 6 do D22 que a porta nao resolve. -->
    <!-- A `key` refaz o quadro quando o país muda: ele busca o ranking uma vez só, ao montar, e
         sem isso o líder trocava o país e via o quadro logo abaixo ainda sem a bandeira. -->
    <ClanRanking
      :key="clan.country || 'sem-pais'"
      :meu-cla-id="clan.id"
      :minha-posicao="clan.rankingPosition"
    />

    <!--
      9. AVISOS e QUADRO (1.1). Sao coisas diferentes e ficam lado a lado de
      proposito: o de cima e o que o LIDER quer que se saiba; o de baixo e o que
      o cla FEZ. Juntar os dois numa lista so faria o recado do lider afundar
      entre vinte doacoes.
    -->
    <section class="cais-do-cla__avisos">
      <ClanAvisos @erro="$emit('chatError', $event)" />
    </section>

    <section class="cais-do-cla__quadro">
      <ClanQuadro @erro="$emit('chatError', $event)" />
    </section>

    <!-- 10. O chat como mural (D13/D22). -->
    <section class="cais-do-cla__mural">
      <ClanChat @error="$emit('chatError', $event)" />
    </section>
  </div>
</template>

<script>
import ClanBoostCard from './ClanBoostCard.vue';
import ClanAvisos from './ClanAvisos.vue';
import ClanQuadro from './ClanQuadro.vue';
import ClanMetaDaSemana from './ClanMetaDaSemana.vue';
import ClanLoja from './ClanLoja.vue';
import ClanPedidos from './ClanPedidos.vue';
import ClanBandeira from './ClanBandeira.vue';
import ClanRanking from './ClanRanking.vue';
import ClanChat from './ClanChat.vue';
import { FishButton, FishIcon } from '@/shared/ui';
import BandeiraDePais from '@/shared/paises/BandeiraDePais.vue';
import EscolhaDePais from '@/shared/paises/EscolhaDePais.vue';
import { nomeDoPais } from '@/shared/paises/paises';
import * as v2 from '@/core/services/api/v2';

export default {
  name: 'ClanDetails',
  components: {
    BandeiraDePais,
    EscolhaDePais,
    ClanBoostCard,
    ClanAvisos,
    ClanQuadro,
    ClanMetaDaSemana,
    ClanLoja,
    ClanPedidos,
    ClanBandeira,
    ClanRanking,
    ClanChat,
    FishButton,
    FishIcon
  },
  props: {
    clan: {
      type: Object,
      required: true
    },
    isLeader: {
      type: Boolean,
      default: false
    }
  },
  emits: ['contribute', 'leave', 'disband', 'kick', 'transfer', 'upgradeBoost', 'activateBoost', 'chatError', 'jogadorMudou'],
  data() {
    return {
      tiposDeBonus: ['moreGold', 'moreExp', 'moreFishingPower'],
      escolhendoPais: false,
      salvandoPais: false,
    };
  },
  computed: {
    nomeDoPaisDoCla() {
      return nomeDoPais(this.clan.country, this.$i18n.locale, (chave) => this.$t(chave));
    },
    playerClanCoins() {
      return this.$store.state.player.clanCoins || 0;
    },
    membros() {
      // O líder tem ficha própria; repetir na lista o mostraria em dobro.
      return (this.clan.members || []).filter((m) => m.id !== this.clan.leader?.id);
    },
    totalDeMembros() {
      return this.membros.length + (this.clan.leader ? 1 : 0);
    },
    /**
     * Quanto da barra de XP do clã está cheio.
     *
     * `xpToNext` é zero no nível máximo — o servidor para de acumular lá. Barra
     * cheia é a leitura certa disso: o clã chegou ao fim da régua, e não a zero.
     */
    percentualDeXp() {
      if (!this.clan.xpToNext) return 100;
      return Math.min(100, Math.round((this.clan.xp / this.clan.xpToNext) * 100));
    },
  },
  methods: {
    formato(n) {
      return new Intl.NumberFormat('pt-BR').format(n || 0);
    },

    /** A troca devolve o país gravado; ele entra na store sem recarregar o clã inteiro. */
    async trocarPais(codigo) {
      this.salvandoPais = true;
      try {
        const r = await v2.trocarPaisDoCla(this.$store.state.player.id, codigo);
        this.$store.commit('clan/SET_CLAN_COUNTRY', r?.pais ?? null);
        this.escolhendoPais = false;
      } catch (error) {
        this.$emit('chatError', error?.response?.data?.message || this.$t('clan.pais.falhou'));
      } finally {
        this.salvandoPais = false;
      }
    },
  },
};
</script>

<style scoped>
.cais-do-cla {
  display: flex;
  flex-direction: column;
  gap: var(--e-4);
}

/* ------------------------------------------------------ a folha de cada seção */

/*
 * TODA seção do cais é papel, e essa é a regra que faltava.
 *
 * Meta, barraca, varal, avisos e quadro escrevem em `--tinta` — a família de
 * cor de quem está SOBRE papel (DESIGN-SYSTEM §3) — mas nasceram sem a folha
 * por baixo, e caíam direto no recife escurecido do `FishScene`. Tinta escura
 * sobre água escura é o texto sumindo, que foi o que o autor viu em 09/09/2026.
 *
 * A folha mora aqui, e não em cada componente, porque quem decide o material de
 * uma seção é a PÁGINA que a compõe: o mesmo `ClanQuadro` posto dentro de outro
 * painel seria papel sobre papel. Os filhos cuidam do miolo; o cais dá o chão.
 */
.cais-do-cla__identidade,
.cais-do-cla__caixa,
.cais-do-cla__meta,
.cais-do-cla__loja,
.cais-do-cla__pedidos,
.cais-do-cla__avisos,
.cais-do-cla__quadro,
.cais-do-cla__ficha {
  border: var(--moldura-borda) solid transparent;
  border-image: url('/ui/frame-panel.png') var(--moldura-fatia) / var(--moldura-borda) repeat;
  background: var(--papel);
  background-clip: padding-box;
  image-rendering: pixelated;
  color: var(--tinta);
}

.cais-do-cla__identidade,
.cais-do-cla__caixa,
.cais-do-cla__meta,
.cais-do-cla__loja,
.cais-do-cla__pedidos,
.cais-do-cla__avisos,
.cais-do-cla__quadro {
  padding: var(--e-3);
}

/* ---------------------------------------------------------------- identidade */

.cais-do-cla__identidade {
  display: flex;
  align-items: flex-start;
  gap: var(--e-3);
}

/*
 * No telefone a identidade vira duas linhas: bandeira e botão em cima, o texto embaixo com a
 * largura inteira. Em fila única, a coluna do meio ficava com ~80px entre o mastro de 72 e o
 * "Dissolver Clã", e cada linha quebrava palavra a palavra — "10 / vagas / · / bônus".
 */
@media (max-width: 599px) {
  .cais-do-cla__identidade {
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .cais-do-cla__identidade > .crescer {
    order: 3;
    flex-basis: 100%;
  }
}

.cais-do-cla__nome {
  margin: 0;
  font-family: var(--fonte-display);
  font-size: var(--f-4);
  font-weight: 400;
  color: var(--tinta);
}

.cais-do-cla__pais {
  margin: var(--e-1) 0 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--e-2);
  font-size: var(--f-2);
  color: var(--tinta);
}

/* O mesmo link tracejado do "trocar a bandeira": as duas trocas são do líder, e falam igual. */
.cais-do-cla__trocar-pais {
  background: none;
  border: 0;
  padding: 0;
  font: inherit;
  font-size: var(--f-1);
  color: var(--latao);
  text-decoration: underline dashed;
  cursor: pointer;
}

.cais-do-cla__escolha-de-pais {
  margin-top: var(--e-2);
}

.cais-do-cla__tipo {
  margin: 2px 0 0;
  display: flex;
  align-items: center;
  gap: var(--e-1);
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

.cais-do-cla__posicao {
  color: var(--latao);
}

.cais-do-cla__descricao {
  margin: var(--e-1) 0 0;
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

/* ----------------------------------------------------- o nível do clã (1.1) */

/* Número, barra e "quanto falta" na MESMA linha: os três são uma informação só,
 * e empilhá-los faria o cabeçalho crescer três vezes por um dado. */
.cais-do-cla__nivel {
  display: flex;
  align-items: center;
  gap: var(--e-2);
  margin-top: var(--e-1);
}

.cais-do-cla__nivel-numero {
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--tinta);
  white-space: nowrap;
}

.cais-do-cla__barra {
  flex: 1;
  min-width: 80px;
  height: 10px;
  background: var(--papel-sombra);
  border: 2px solid var(--madeira);
  overflow: hidden;
}

.cais-do-cla__barra-cheia {
  display: block;
  height: 100%;
  background: var(--latao);
  transition: width 0.4s ease-out;
}

.cais-do-cla__nivel-falta {
  font-size: var(--f-1);
  color: var(--tinta-fraca);
  white-space: nowrap;
}

/* O que o nível LIBERA, escrito. Sem isto ele seria decorativo — o problema 2
 * do D22 transplantado para um lugar novo. */
.cais-do-cla__libera {
  margin: var(--e-1) 0 0;
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

/* --------------------------------------------------------------------- bônus */

.cais-do-cla__bonus {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: var(--e-3);
}

/* --------------------------------------------------------------------- caixa */

.cais-do-cla__caixa {
  display: flex;
  align-items: center;
  gap: var(--e-3);
}

.cais-do-cla__saldo {
  margin: 0;
  font-size: var(--f-4);
  color: var(--tinta);
}

.cais-do-cla__saldo-rotulo {
  margin: 0;
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

.cais-do-cla__moedas {
  margin: var(--e-1) 0 0;
  display: flex;
  align-items: center;
  gap: var(--e-1);
  font-size: var(--f-1);
  color: var(--tinta-fraca);
}

.cais-do-cla__moedas strong {
  color: var(--latao);
}

/* --------------------------------------------------------------- tripulação */

.cais-do-cla__rotulo {
  margin: 0 0 var(--e-2);
  font-family: var(--fonte-display);
  font-size: var(--f-2);
  color: var(--papel-luz);
  text-shadow: 1px 1px 0 var(--agua-abissal);
}

.cais-do-cla__fichas {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: var(--e-2);
}

.cais-do-cla__ficha {
  display: flex;
  align-items: center;
  gap: var(--e-2);
  padding: var(--e-2);
  font-size: var(--f-1);
}

.cais-do-cla__ficha--lider {
  border-bottom: 4px solid var(--latao);
}

.cais-do-cla__mando {
  display: flex;
  gap: var(--e-1);
}

.cais-do-cla__mandinho {
  background: none;
  border: none;
  padding: var(--e-1);
  cursor: pointer;
  color: var(--tinta-fraca);
}

@media (hover: hover) {
  .cais-do-cla__mandinho:hover {
    color: var(--tinta);
  }
}
</style>
